import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 25 23',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2">
        <path
          fill={fill}
          d="M22.656,36.929H17.188v-3.7A1.2,1.2,0,0,0,16.016,32H8.984a1.2,1.2,0,0,0-1.172,1.232v3.7H2.344A2.406,2.406,0,0,0,0,39.393V52.536A2.406,2.406,0,0,0,2.344,55H22.656A2.406,2.406,0,0,0,25,52.536V39.393A2.406,2.406,0,0,0,22.656,36.929ZM9.375,33.643h6.25v3.286H9.375ZM23.438,52.536a.8.8,0,0,1-.781.821H2.344a.8.8,0,0,1-.781-.821V45.143H9.375V47.2a1.2,1.2,0,0,0,1.172,1.232h3.906A1.2,1.2,0,0,0,15.625,47.2V45.143h7.813Zm-12.5-5.75V45.143h3.125v1.643Zm12.5-3.286H1.563V39.393a.8.8,0,0,1,.781-.821H22.656a.8.8,0,0,1,.781.821Z"
          transform="translate(0 -32)"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
